import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from "@iconify/react";
import { useDispatch } from 'react-redux';
// css
import './Changepw.css'
// custom imports 
import userManagementService from '../../../Services/UserManagement/UserManagementService';
import { hideLoader, showLoader } from '../../../Redux/Slice/Loader/loaderSlice';
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError';
import showToast from '../../../Utils/Toast/ToastNotification';
import { useNavigate } from 'react-router-dom';

const Changepw = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userData = useSelector((state) => state.auth.user.data?.body?.data)
  const token = userData?.token

  // states
  const [data, setData] = useState({
    user_id: userData?.userData.id,
    old_password: "",
    new_password: "",
    confirm_password: ""
  })

  const [error, setErrors] = useState({
    old_password: "",
    new_password: "",
    confirm_password: ""
  })
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  // handle chnage
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  // validation
  const validateForm = () => {
    const { old_password, new_password, confirm_password } = data;
    const newErrors = {
      old_password: '',
      new_password: '',
      confirm_password: ''
    };

    let isValid = true;

    if (!old_password) {
      newErrors.old_password = "Old password is required";
      isValid = false;
    }

    if (!new_password) {
      newErrors.new_password = "New password is required";
      isValid = false;
    } else {
      const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!passwordRegex.test(new_password)) {
        newErrors.new_password = "Password must be at least 8 characters, include 1 uppercase, 1 number, and 1 special character";
        isValid = false;
      }
    }

    if (!confirm_password) {
      newErrors.confirm_password = "Confirm password is required";
      isValid = false;
    } else if (new_password !== confirm_password) {
      newErrors.confirm_password = "Passwords do not match";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  //  handle submit
  const handleSubmit = async () => {
    if (!validateForm()) return;

    dispatch(showLoader())
    try {
      const response = await userManagementService.changePassword(data, token)
      if (response?.data?.statusCode === 200) {
        showToast("success", response?.data?.body.message)
        setData({
          user_id: userData?.userData.id,
          old_password: "",
          new_password: "",
          confirm_password: ""
        });
        setErrors({
          old_password: "",
          new_password: "",
          confirm_password: ""
        });
      }
      else {
        showToast("error", response.data.body.message);
      }
    } catch (error) {
      await HandleApiError(error)
    } finally {
      dispatch(hideLoader())
    }
  }
  return (
    <div>
      <div className='main-inner-block'>
        <div className='content'>
          <div className='white-box'>
            <div className='inner-content-blk'>
              <div className='listing-title-block d-flex justify-content-between pt-0 ps-0 align-items-center'>
                <div className='box-listing-title profile_heading'>
                  Settings
                </div>
              </div>

            </div>

            <div class="create-user-block">
              <div className="add-project-area ">
                {/* changepassword details block */}
                <div className="add-project-inner">
                  <h6 className="heading-content m-0 heading-text">Change Password</h6>
                  <div className="project-details-section row">
                    <div className="add-project-box col-md-4 mb-3">
                      <label htmlFor="old_password" className="form-label m-0">
                        Old Password <span>*</span>
                      </label>
                      <div className="input-group input-blk">
                        <input
                          type="text"
                          id="old_password"
                          className="form-control"
                          placeholder='Old Password'
                          name="old_password"
                          value={data.old_password}
                          onChange={handleChange}
                        />
                      </div>

                      {error.old_password && <div className="error">{error.old_password}</div>}
                    </div>

                    {/* new password */}
                    <div className="add-project-box col-md-4 mb-3">
                      <label htmlFor="new_password" className="form-label m-0">
                        New Password <span>*</span>
                      </label>
                      <div className="input-group input-blk">
                        <input
                          type={showPassword ? "text" : "password"}
                          id="new_password"
                          className="form-control"
                          placeholder='New Password'
                          name="new_password"
                          value={data.new_password}
                          onChange={handleChange}
                        />
                        <div
                          className="eye-icon"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? (
                            <Icon icon="mdi:eye" width="24" height="24" />
                          ) : (
                            <Icon icon="mdi:eye-off" width="24" height="24" />
                          )}
                        </div>
                      </div>
                      {error.new_password && <div className="error">{error.new_password}</div>}
                    </div>

                    {/* confirm password */}
                    <div className="add-project-box col-md-4 mb-3">
                      <label htmlFor="confirm_password" className="form-label m-0">
                        Confirm Password <span>*</span>
                      </label>
                      <div className="input-group input-blk">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          id="confirm_password"
                          className="form-control"
                          placeholder='Confirm Password'
                          name="confirm_password"
                          value={data.confirm_password}
                          onChange={handleChange}
                        />
                        <div
                          className="eye-icon"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          style={{ cursor: "pointer" }}
                        >
                          {showConfirmPassword ? (
                            <Icon icon="mdi:eye" width="24" height="24" />
                          ) : (
                            <Icon icon="mdi:eye-off" width="24" height="24" />
                          )}
                        </div>
                      </div>
                      {error.confirm_password && <div className="error">{error.confirm_password}</div>}
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div className="text-center update-div d-flex align-items-center justify-content-center gap-2">
              <button
                type="button"
                className="green-btn submit-btn"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              <button
                type="button"
                class="green-btn submit-btn"
                onClick={handleSubmit}
              >
                Change Password
              </button>
            </div>
          </div>

        </div>

      </div>
    </div>
  )
}

export default Changepw